export default __webpack_public_path__ + "static/media/pic1.460e9b32.jpg";